import $ from 'jquery';

$( document ).ready( function() {
	$( document.body ).on( 'click', '.trigger-conversion', function( evt ) {
		const form = $( '#conversion' ).find( '.form' );

		evt.preventDefault();

		$( 'body' ).toggleClass( 'fixed' );
		$( '#conversion' ).toggleClass( 'open' );
		form.find( 'legend' ).text( $( this ).attr( 'data-title' ) );
		form.slideToggle();
	} );
	$( document.body ).on( 'click', '.close-conversion', function( evt ) {
		const form = $( '#conversion' ).find( '.form' );

		evt.preventDefault();

		$( 'body' ).removeClass( 'fixed' );
		$( '#conversion' ).removeClass( 'open' );
		form.slideToggle();
	} );
} );
